<div class="card">
	<div class="card-header">{{ 'SERVICE_SELECTION_CONFIRM_TITLE' | translate }}</div>
	<div class="card-body">
		<p>{{ 'SERVICE_SELECTION_CONFIRM_MESSAGE' | translate }}</p>
		<div class="table-responsive">
			<table class="table table-striped table-bordered">
				<tbody>
					<tr>
						<th>{{ 'OTP_METHOD' | translate }}</th>
						<td *ngIf="isOtpMethodEmail()">{{ 'OTP_EMAIL' | translate }}</td>
						<td *ngIf="!isOtpMethodEmail()">{{ 'OTP_SMS' | translate }}</td>
					</tr>
					<tr *ngIf="isOtpMethodEmail()">
						<th>{{ 'EMAIL_ADDRESS' | translate }}</th>
						<td>{{ serviceSelection.email }}</td>
					</tr>
					<tr *ngIf="!isOtpMethodEmail()">
						<th>{{ 'MOBILE_NUMBER' | translate }}</th>
						<td>{{ serviceSelection.msisdn }}</td>
					</tr>
					<tr *ngIf="serviceSelection.idType">
						<th>{{ 'ID_TYPE' | translate }}</th>
						<td>{{ serviceSelection.idType }}</td>
					</tr>
					<tr *ngIf="serviceSelection.idNumber">
						<th>{{ 'ID_NUMBER' | translate }}</th>
						<td>{{ serviceSelection.idNumber }}</td>
					</tr>
					<tr *ngIf="serviceSelection.name">
						<th>{{ 'NAME' | translate }}</th>
						<td>{{ serviceSelection.name }}</td>
					</tr>
					<tr *ngIf="serviceSelection.surname">
						<th>{{ 'SURNAME' | translate }}</th>
						<td>{{ serviceSelection.surname }}</td>
					</tr>
					<tr *ngIf="serviceSelection.gender">
						<th>{{ 'GENDER' | translate }}</th>
						<td>{{ serviceSelection.gender }}</td>
					</tr>
					<tr *ngIf="serviceSelection.dateOfBirth">
						<th>{{ 'DOB' | translate }}</th>
						<td>{{ serviceSelection.dateOfBirth | date: 'dd/MM/yyyy' }}</td>
					</tr>
					<tr>
						<th>{{ 'PROVINCE' | translate }}</th>
						<td>{{ serviceSelection.province }}</td>
					</tr>
					<tr>
						<th>{{ 'MUNICIPALITY' | translate }}</th>
						<td>{{ serviceSelection.municipality }}</td>
					</tr>
					<tr>
						<th>{{ 'COMMUNE' | translate }}</th>
						<td>{{ serviceSelection.commune }}</td>
					</tr>
					<tr>
						<th>{{ 'CAP' | translate }}</th>
						<td>{{ serviceSelection.cap }}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<!-- <div class="row">
			<div class="col info-title">{{ 'OTP_METHOD' | translate }}</div>
			<div class="col" *ngIf="isOtpMethodEmail()">{{'OTP_EMAIL' | translate}}</div>
			<div class="col" *ngIf="!isOtpMethodEmail()">{{'OTP_SMS' | translate}}</div>
		</div>
		<div class="row" *ngIf="isOtpMethodEmail()">
			<div class="col info-title">{{ 'EMAIL_ADDRESS' | translate }}</div>
			<div class="col">{{serviceSelection.email}}</div>
		</div>
		<div class="row" *ngIf="!isOtpMethodEmail()">
			<div class="col info-title">{{ 'MOBILE_NUMBER' | translate }}</div>
			<div class="col">{{serviceSelection.msisdn}}</div>
		</div>
		<div class="row">
			<div class="col info-title">{{ 'ID_TYPE' | translate }}</div>
			<div class="col">{{serviceSelection.idType}}</div>
		</div>
		<div class="row">
			<div class="col info-title">{{ 'ID_NUMBER' | translate }}</div>
			<div class="col">{{serviceSelection.idNumber}}</div>
		</div>
		<div class="row">
			<div class="col info-title">{{ 'NAME' | translate }}</div>
			<div class="col">{{serviceSelection.name}}</div>
		</div>
		<div class="row">
			<div class="col info-title">{{ 'SURNAME' | translate }}</div>
			<div class="col">{{serviceSelection.surname}}</div>
		</div>
		<div class="row">
			<div class="col info-title">{{ 'GENDER' | translate }}</div>
			<div class="col">{{serviceSelection.gender}}</div>
		</div>
		<div class="row">
			<div class="col info-title">{{ 'DOB' | translate }}</div>
			<div class="col">{{serviceSelection.dateOfBirth}}</div>
		</div>
		<div class="row">
			<div class="col info-title">{{ 'PROVINCE' | translate }}</div>
			<div class="col">{{serviceSelection.province}}</div>
		</div>
		<div class="row">
			<div class="col info-title">{{ 'MUNICIPALITY' | translate }}</div>
			<div class="col">{{serviceSelection.municipality}}</div>
		</div>
		<div class="row">
			<div class="col info-title">{{ 'COMMUNE' | translate }}</div>
			<div class="col">{{serviceSelection.commune}}</div>
		</div>
		<div class="row">
			<div class="col info-title">{{ 'CAP' | translate }}</div>
			<div class="col">{{serviceSelection.cap}}</div>
		</div> -->
		<p><i class="bi bi-exclamation-triangle-fill text-warning me-2"></i> {{ 'SERVICE_SELECTION_CONFIRM_WARNING' | translate }}</p>
		<p>{{ 'SERVICE_SELECTION_CONFIRM_INSTRUCTION' | translate }}</p>
	</div>
	<div class="card-footer">
		<div class="dialog-actions">
			<button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="onConfirm()">Confirm</button>
		</div>
	</div>
</div>